import React from 'react';
import Icon from '@ant-design/icons';

type IconProps = React.ComponentProps<typeof Icon>;

const IconComponent = () => (
  <svg viewBox="0 0 20 20">
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-20.000000, -115.000000)" fill="#3B3B43" fillRule="nonzero">
        <g transform="translate(20.000000, 115.000000)">
          <path d="M18.1640628,4.7832032 C18.1640628,4.7832032 4.29687506,4.80273445 3.0273438,4.7832032 C1.75781253,4.76367195 2.05078128,3.84570318 2.05078128,3.84570318 L17.9296878,2.28320316 L17.9296878,0.798828137 C17.7871096,-0.0800781262 16.4843752,-0.0390625006 16.0546877,0.0566406258 L1.27148439,2.69140629 C0.287109379,2.91406254 0,4.33398444 0,4.33398444 L0,18.0449221 C0.541015633,19.8750003 1.93359378,19.9609378 1.93359378,19.9609378 L18.105469,19.9609378 C19.6289065,19.9609378 20,17.9667971 20,17.9667971 L20,6.73632823 C20,5.2910157 18.1640628,4.7832032 18.1640628,4.7832032 Z M16.4550784,13.9628908 C15.5859377,13.9628908 14.8828127,13.2597658 14.8828127,12.3906252 C14.8828127,11.5214845 15.5859377,10.8183595 16.4550784,10.8183595 C17.324219,10.8183595 18.027344,11.5214845 18.027344,12.3906252 C18.027344,13.2597658 17.324219,13.9628908 16.4550784,13.9628908 Z"></path>
        </g>
      </g>
    </g>
  </svg>
);

const MenuWalletIcon = (props: IconProps) => <Icon component={IconComponent} {...props} />;

export default MenuWalletIcon;
